import React, { useEffect, useState } from 'react';
import './Header.css';
import logoSnoop from '../../assets/logo snoop.svg';
import Avatar from '@mui/material/Avatar';
import { History } from 'history';
import { Text } from '@fluentui/react/lib/Text';
import { Pivot, PivotItem } from '@fluentui/react/lib/Pivot';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import Options from './Options/Options';
import useOnClickOutside from './Hooks/useOnClickOutside';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchBar from '../SearchBar/SearchBar';
import EnvironmentViewer from './EnvironmentViewer/EnvironmentViewer';
import UpdateMGMT from './UpdateMGMT/UpdateMGMT';
import UserMenu from './UserMenu/UserMenu';

interface Props {
  nombreProyecto?: string;
  history: History;
  userName: string;
  userImageUrl: string;
  selectedKey?: string;
  handleChangeSearch?: any;
  ultimaActualizacion?: string;
  idProyecto?: string;
}

const Header: React.FC<Props> = (props: Props) => {
  const [showOptions, setShowOptions] = useState(false);
  const nombreProyecto = props.nombreProyecto || '';
  const optionsRef = React.createRef();
  useOnClickOutside(optionsRef, () => setShowOptions(false));

  const onPressInicio = () => {
    props.history.push('/');
  };

  const toggleShowOptions = () => {
    setShowOptions(!showOptions);
  }

  const onLinkClick = (item: PivotItem) => {
    switch (item.props.itemKey) {
      case 'proyecto':
        break;
      case 'inicio':
        onPressInicio();
        break;
    }
  };

  useEffect(() => {

  }, [props.ultimaActualizacion]);

  return (
  <div className="header-container" style={{ boxShadow: Depths.depth4, zIndex: 5 }}>
    <div className="header-wrapper">
      <div className="header-left">
        <img className="header-logo" src={logoSnoop} alt="Logo snoop" onClick={onPressInicio}/>
        <Pivot onLinkClick={onLinkClick} selectedKey={props.selectedKey || undefined}>
          <PivotItem onClick={onPressInicio} headerText={'Inicio'} itemKey={'inicio'} />
          {nombreProyecto ? <PivotItem headerText={''} itemKey={'proyecto'}/> : null}
        </Pivot>
        <Text className="header-title">Certificación de horas</Text>
      </div>

      <div className="header-right" style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <UpdateMGMT lastUpdated={props.ultimaActualizacion ?? undefined} idProyecto={props.idProyecto} />
        <div style={{ flexGrow: 1 }} />
        <EnvironmentViewer />
        <UserMenu userName={props.userName} userImageUrl={props.userImageUrl} />
      </div>
    </div>
  </div>
  );
};

export default Header;
